import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const ActivityFormWrapper = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .notes {
    padding-top: 24px;

    ${responsive.MOBILE`
      padding-top: 0;    
    `}
  }
`;
